import { AutogenModelLoadBoardService, AutogenRowLoadBoardService } from "./autogen/AutogenModelLoadBoardService";

export class ModelLoadBoardService extends AutogenModelLoadBoardService<RowLoadBoardService> {
	constructor() {
		super(RowLoadBoardService);
	}
}

export class RowLoadBoardService extends AutogenRowLoadBoardService {
}